import { render, staticRenderFns } from "./iFeelReport.vue?vue&type=template&id=88d56254&scoped=true&"
import script from "./iFeelReport.vue?vue&type=script&lang=js&"
export * from "./iFeelReport.vue?vue&type=script&lang=js&"
import style0 from "./iFeelReport.vue?vue&type=style&index=0&id=88d56254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d56254",
  null
  
)

export default component.exports